export default "__VITE_ASSET__CT9UTWSG__"